<template>
  <div class="form-content">
    <v-sheet
      color="white"
      elevation="2"
    >
      <v-container class="tw-relative">
        <v-overlay :value="isProcessing" absolute z-index="1" class="tw-rounded-lg" />
        <v-progress-linear
          :active="isProcessing"
          :indeterminate="isProcessing"
          absolute
          top
          color="grey darken-4"
          class="tw-rounded-t-xl"
        />
        <validation-observer
          ref="observer"
          v-slot="{ invalid }"
        >
          
          <form @submit.prevent="doSubmit">
            <v-row>
              <v-col cols="12" class="tw-px-4 tw-pt-6 tw-pb-10">
                <validation-provider
                  v-slot="{ errors }"
                  name="email"
                  rules="required|email"
                >
                  <v-text-field
                    :value="form.email"
                    :error-messages="errors"
                    label="E-mail"
                    placeholder="Email..."
                    outlined
                    required
                    @input="(x) => doUpdateData(x, 'email')"
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="code"
                  rules="required|min:6|numeric"
                >
                  <v-text-field
                    :class="{'vee-error': errors.length}"
                    :value="form.code"
                    :error-messages="errors"
                    label="Code"
                    type="text"
                    placeholder="Enter code here..."
                    outlined
                    required
                    @input="(x) => doUpdateData(x, 'code')"
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-slot="{ errors }"
                  name="password"
                  rules="required|min:8|verify_password"
                >
                  <div class="tw-flex tw-relative">
                    <v-text-field
                      :class="{'vee-error': errors.length}"
                      :value="form.password"
                      :error-messages="errors"
                      label="Password"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Password..."
                      outlined
                      required
                      @input="(x) => doUpdateData(x, 'password')"
                    ></v-text-field>
                    <v-img
                      class="tw-absolute tw-right-3 tw-top-3.5 tw-cursor-pointer"
                      max-height="24"
                      max-width="24"
                      :src=" showPassword ? require('@/assets/icons/ic-eye-open.svg') :require('@/assets/icons/ic-eye-close.svg')"
                      @click="showPassword = !showPassword"
                    />
                  </div>
                </validation-provider>
                <div>
                  <v-btn
                    class="tw-w-full tw-mb-3"
                    color="primary"
                    type="submit"
                    :disabled="invalid"
                    large
                  >
                    Update Password
                  </v-btn>
                </div>
                <div class="tw-text-center tw-py-0 tw-flex tw-flex-col tw-justify-between">
                  <div>
                    <v-btn 
                      plain
                      class="tw-cursor-pointer"
                      :disabled="isResend"
                      @click="doResendCode()"
                    >
                      <small>Resend Code</small>
                    </v-btn>
                    <span v-if="isResend" class="tw-px-1">
                      <small>after {{timeleft}} seconds</small>
                    </span>
                  </div>
                  <div>
                    <v-btn 
                      plain
                      class="tw-cursor-pointer"
                    >
                      <router-link class="tw-underline" :to="{ name: ROUTE_SIGNIN }">
                        <small>Log In</small>
                      </router-link>
                      
                    </v-btn>
                  </div>
                </div>
                <!-- <v-btn @click="clear">
                  clear
                </v-btn> -->
              </v-col>
            </v-row>
          </form>
        </validation-observer>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>

//utilities
import {
  ROUTE_SIGNIN,
} from '@/constants'

export default {
  name : 'SignUpForm',
  props: [
    'form',
    'doSubmit',
    'doUpdateData',
    'doResendCode',
    'isProcessing',
    'timeleft',
    'isResend',

  ],

  data: () => ({
    //not state management data
    ROUTE_SIGNIN: ROUTE_SIGNIN,
    showPassword: false,
  }),

}
</script>

<style>

</style>